import type { CAPRouter } from "@phc/cap-service"
import { createTRPCContext } from "@trpc/tanstack-react-query"

// cap: content access proxy
export const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<CAPRouter>()
